import {createAction} from 'redux-act';

export const openTaskManager = createAction('Open task manager', (panelSetId) => ({panelSetId}));
export const closeTaskManager = createAction('Close task manager');
